import React from 'react';
import { ArrowRight, MessageCircle } from 'lucide-react';
import { trackCTAClick, trackWhatsAppClick } from '../analytics';
import './CTAButton.css';

const CTAButton = ({ 
  variant = 'primary', 
  size = 'medium', 
  fullWidth = false,
  children, 
  onClick,
  href,
  trackingLabel,
  isWhatsApp = false,
  subtext,
  icon,
  disabled = false
}) => {
  const baseClass = 'cta-button';
  const variantClass = `${baseClass}--${variant}`;
  const sizeClass = `${baseClass}--${size}`;
  const widthClass = fullWidth ? `${baseClass}--full-width` : '';
  const classes = [baseClass, variantClass, sizeClass, widthClass].filter(Boolean).join(' ');

  const handleClick = (e) => {
    if (disabled) return;

    // Tracking
    if (isWhatsApp) {
      trackWhatsAppClick(window.location.pathname + window.location.search + window.location.hash);
    } else if (trackingLabel) {
      trackCTAClick(trackingLabel, window.location.pathname + window.location.search + window.location.hash);
    }

    // Custom onClick
    if (onClick) {
      onClick(e);
    }

    // WhatsApp redirect
    if (isWhatsApp && href) {
      window.open(href, '_blank', 'noopener,noreferrer');
    }
  };

  const buttonContent = (
    <>
      {icon && <span className="cta-button__icon">{icon}</span>}
      <span className="cta-button__text">{children}</span>
      {!isWhatsApp && <ArrowRight size={16} className="cta-button__arrow" />}
      {isWhatsApp && <MessageCircle size={16} className="cta-button__arrow" />}
    </>
  );

  if (href) {
    return (
      <div className="cta-button-wrapper">
        <a
          href={href}
          className={classes}
          onClick={handleClick}
          target="_blank"
          rel="noopener noreferrer"
          disabled={disabled}
        >
          {buttonContent}
        </a>
        {subtext && <p className="cta-button__subtext">{subtext}</p>}
      </div>
    );
  }

  return (
    <div className="cta-button-wrapper">
      <button
        className={classes}
        onClick={handleClick}
        disabled={disabled}
      >
        {buttonContent}
      </button>
      {subtext && <p className="cta-button__subtext">{subtext}</p>}
    </div>
  );
};

export default CTAButton;
